/**
 * O aviso de versão nova — a metade da atualização que faltava.
 *
 * `registerType: 'prompt'` sempre foi decisão consciente (vite.config.ts):
 * trocar o service worker sob os pés de quem está com um formulário aberto
 * recarrega a página e perde o que estava digitado. O que não existia era o
 * **prompt**: sem ele, a versão nova ficava em espera para sempre e o deploy
 * não chegava a ninguém.
 *
 * A barra fica até a pessoa decidir. Um toast de 8 s seria pior que nada aqui —
 * some antes de quem está no meio de uma frase terminar de ler, e a próxima
 * chance só apareceria no próximo deploy.
 */
import { useSyncExternalStore } from 'react';
import {
  aplicarAtualizacao,
  assinarAtualizacao,
  atualizacaoPendente,
} from '../../lib/atualizacao.js';

export function AtualizacaoDisponivel() {
  // `useSyncExternalStore` porque o estado vive fora do React: quem descobre a
  // versao nova e o navegador, num callback do registro do service worker.
  const pendente = useSyncExternalStore(assinarAtualizacao, atualizacaoPendente, () => false);

  if (!pendente) return null;

  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-between gap-2 bg-brand-navy px-4 py-2 text-sm text-white"
    >
      <span>Uma versão nova do ClearTask está pronta.</span>

      <button
        type="button"
        onClick={aplicarAtualizacao}
        className="min-h-touch rounded-sm bg-surface px-3 font-medium text-brand-navy"
      >
        Atualizar agora
      </button>
    </div>
  );
}
